module.exports = __webpack_public_path__ + "img/Landscape Efest - Revisi.74dd50f9.jpg";